export default __webpack_public_path__ + "static/media/logolp.602a66cb.png";